module.exports = __webpack_public_path__ + "img/bg.7439fd09.jpg";